import React, { useState } from 'react';
import { SubmitButton } from 'Components/Fields/Buttons';
import { Modal } from 'Components/Modal';
import { RadioButton } from 'Components/Fields/RadioButton';

import './ShippingFormVerificationModal.css';

const defaultSelected = 'verified';
const titlesMap = {
  default: 'Select address',
  checked: 'Ship to this address',
};

export const ShippingFormVerificationModal = ({ isOpen, onClose, addressMap, onContinue }) => {
  const [checked, setChecked] = useState(defaultSelected);
  const keys = Object.keys(addressMap);
  const onClick = (event) => {
    onContinue(event, addressMap[checked], true);
  };
  return (
    <Modal isShowing={isOpen} onClose={onClose}>
      <div className="shippingFormVerificationModal">
        <div className="shippingFormVerificationModalTitle">Shipping Address</div>
        <ul className="addressesList">
          {keys.map((key) => {
            const { firstName, lastName, address1, address2 = '', city, state, zipCode } = addressMap[key];
            const userName = `${firstName} ${lastName}`;
            const addressLine1 = `${address1} ${address2}`;
            const addressLine2 = `${city}, ${state} ${zipCode}`;
            const isChecked = key === checked;
            const isRecommended = key === defaultSelected;
            const title = isChecked ? titlesMap.checked : titlesMap.default;
            return (
              <li className={`addressListItem ${isChecked ? 'checked' : ''}`} key={key}>
                {isRecommended && <div className="recommended">Recommended Verified Address</div>}
                <div className="flexSplit2">
                  <div className="addressDetails" data-dd-privacy="mask">
                    <div>{userName}</div>
                    <div>{addressLine1}</div>
                    <div>{addressLine2}</div>
                  </div>
                  <RadioButton
                    name="shipping"
                    id={key}
                    onChange={setChecked}
                    value={key}
                    checked={isChecked}
                    title={title}
                    customClass="shippingRadioButton"
                  />
                </div>
              </li>
            );
          })}
        </ul>
        <SubmitButton text="Continue" onClick={onClick} />
      </div>
    </Modal>
  );
};
